import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { BlacklistAddressQueryInput, PaginatedAddressTypeResponse } from '@/models/blacklistAddress';

export const fetchBlacklistAddresses = async ({
  streetAddress,
  city,
  state,
  zip,
  country,
  reason,
  pagination,
}: BlacklistAddressQueryInput): Promise<PaginatedAddressTypeResponse> => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      streetAddress,
      city,
      state,
      zip,
      country,
      reason,
      pagination,
    },
    query: graphql(`
      query Addresses(
        $streetAddress: String
        $city: String
        $state: String
        $zip: String
        $country: String
        $reason: String
        $pagination: PaginationInputType
      ) {
        addresses(
          streetAddress: $streetAddress
          city: $city
          state: $state
          zip: $zip
          country: $country
          reason: $reason
          pagination: $pagination
        ) {
          count
          rows {
            id
            name
            partnerCodeName
            phoneNumber
            streetAddress
            streetAddress2
            city
            state
            country
            zip
            latitude
            longitude
            radius
            reason
            blackListedAt
            flaggedAt
            createdAt
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.addresses!;
};
